import { HttpParams } from '@angular/common/http';

import { toHTTPParam } from '../../../../core';
import { Filter } from '../../../../models';
import { Cidade } from '../../../cidade';
import { Representante } from '../../representante';
import { Cliente } from '../cliente';

/** Representa o Filter da entidade Cliente */
export class ClienteFilter implements Filter {
    isFilterDirty = false;

    /** Cadastro */
    somenteClientesEmCarteira: boolean; // Somente os clientes em carteira (clientes com cadastro igual a cliente)
    somenteClientesEmCarteiraAtiva: boolean; // Somente os clientes em carteira (clientes com cadastro igual a cliente) que estão com situação igual a Ativo
    somenteClientesEmCarteiraInativa: boolean; // Somente os clientes em carteira (clientes com cadastro igual a cliente) que estão com situação igual a Inativo
    somenteClientes: boolean; // Somente os clientes com cadastro igual a cliente
    somenteClientesProspects: boolean; // Somente os clientes com cadastro prospect
    somenteClientesCongelados: boolean; // Somente os clientes com cadastro congelado
    somenteClientesBloqueados: boolean; // Somente os clientes com cadastro bloqueado
    somenteClientesBaixados: boolean; // Somente os clientes com cadastro baixado
    somenteClientesOutros: boolean; // Somente os clientes com cadastro outros
    cadastro: number;
    cadastros: number[] = []; // Lista de cadastros

    /** Situação */
    somenteClientesAtivos: boolean; // Somente os clientes com a situação ativo
    somenteClientesInativos: boolean; // Somente os clientes com a situação inativo
    situacao: number;
    situacoes: number[] = []; // Lista de situações

    origens: number[] = [];
    idsCampanhasOrigens: number[] = [];
    campanhaOrigemNull = false;
    somenteCampanhasOrigemEmAndamento = true;
    idsCampanhasAquisicoes: number[] = [];
    campanhaAquisicaoNull = false;
    somenteCampanhasAquisicaoEmAndamento = true;
    idsCampanhasOrigensAquisicoes: number[] = [];
    campanhaOrigemAquisicaoNull = false;
    canaisMidiasSociais: number[] = [];
    canalMidiaSocialNull = false;
    idsCanaisVendaOrigem: number[] = [];
    tipoPessoa: number;
    tiposPessoas: number[] = [];
    idsPeriodicidadesCompras: number[] = [];
    periodicidadeCompraSemana: number[] = [];
    idsClassificacoes: number[] = [];
    classificacaoNull = false;
    idClienteGrupoEconomico: number;
    clienteAbc: number;
    filterPsq: string;
    cnpjCpf: string;
    codigoIntegracaoErp: string;
    idRepresentante: number;
    representante: Representante;
    idsOutrosRepresentantes: number[] = []; // Para quando for pesquisado por mais de 1 representante
    somenteRepresentantesAtivos = true; // Para o multiselect dos representantes
    semRepresentante = false;
    idsAtendentes: number[];
    idClienteAtual: number;
    idsIgnore: number[] = []; // ID's dos clientes que devem ser ignorados e não devem retornar nas pesquisas
    idCidade: number;
    idCidadeSubRegiao: number;
    idCidadeSubRegiaoBairro: number;
    cidade: Cidade;
    idEstado: number;
    idClienteCentralCompras: number;
    clienteCentralCompras: Cliente;
    somenteCentralDeCompra: boolean;
    somenteCentralDeCompraV1: boolean;
    somenteParticipaveisCentalDeCompra: boolean;
    dataCadastroInicial: Date;
    dataCadastroFinal: Date;
    statusesAnaliseFinanceira: number[] = [];
    idsRegioes: number[] = [];
    regiaoNull = false;
    somenteRegioesAtivas = true; // Para o multiselect das regiões
    idsTags: number[] = []; // IDs das tags associadas ao cliente
    idsRepresentantes: number[] = []; // IDs dos representantes associados ao cliente
    idsPessoas: number[] = []; // IDs das pessoas associadas ao cliente

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        /** Cadastro */
        if (this.somenteClientesEmCarteira) {
            params = params.append('somenteClientesEmCarteira', this.somenteClientesEmCarteira.toString());
        }
        if (this.somenteClientesEmCarteiraAtiva) {
            params = params.append('somenteClientesEmCarteiraAtiva', this.somenteClientesEmCarteiraAtiva.toString());
        }
        if (this.somenteClientesEmCarteiraInativa) {
            params = params.append('somenteClientesEmCarteiraInativa', this.somenteClientesEmCarteiraInativa.toString());
        }
        if (this.somenteClientes) {
            params = params.append('somenteClientes', this.somenteClientes.toString());
        }
        if (this.somenteClientesProspects) {
            params = params.append('somenteClientesProspects', this.somenteClientesProspects.toString());
        }
        if (this.somenteClientesBloqueados) {
            params = params.append('somenteClientesBloqueados', this.somenteClientesBloqueados.toString());
        }
        if (this.somenteClientesCongelados) {
            params = params.append('somenteClientesCongelados', this.somenteClientesCongelados.toString());
        }
        if (this.somenteClientesBaixados) {
            params = params.append('somenteClientesBaixados', this.somenteClientesBaixados.toString());
        }
        if (this.somenteClientesOutros) {
            params = params.append('somenteClientesOutros', this.somenteClientesOutros.toString());
        }
        if (this.cadastro) {
            params = params.append('cadastro', this.cadastro.toString());
        }

        if (this.cadastros && this.cadastros.length > 0) {
            this.cadastros.forEach(cadastro => {
                params = params.append('cadastro', cadastro.toString());
            });
        }

        if (this.idsTags && this.idsTags.length > 0) {
            this.idsTags.forEach(idTag => {
                params = params.append('idsTags', idTag.toString());
            });
        }

        /** Pessoas */
        if (this.idsRepresentantes && this.idsRepresentantes.length > 0) {
            this.idsRepresentantes.forEach(idRepresentante => {
                params = params.append('idsRepresentantes', idRepresentante.toString());
            });
        }

        if (this.idsPessoas && this.idsPessoas.length > 0) {
            this.idsPessoas.forEach(idPessoa => {
                params = params.append('idsPessoas', idPessoa.toString());
            });
        }

        /** Situação */
        if (this.somenteClientesAtivos) {
            params = params.append('somenteClientesAtivos', this.somenteClientesAtivos.toString());
        }
        if (this.somenteClientesInativos) {
            params = params.append('somenteClientesInativos', this.somenteClientesInativos.toString());
        }
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        } else if (this.situacoes && this.situacoes.length > 0) {
            this.situacoes.forEach(situacao => {
                params = params.append('situacao', situacao.toString());
            });
        }

        // Origens
        this.origens?.forEach(origem => {
            params = params.append('origem', origem.toString());
        });

        // IDs Campanhas de Origens
        this.idsCampanhasOrigens?.forEach(idCampanhaOrigem => {
            if (idCampanhaOrigem > 0) {
                params = params.append('idCampanhaOrigem', idCampanhaOrigem.toString());
            }
        });
        // Sem campanha de origem
        if (this.campanhaOrigemNull) {
            params = params.append('campanhaOrigemNull', 'true');
        }

        // IDs Campanhas de Aquisições
        this.idsCampanhasAquisicoes?.forEach(idCampanhaAquisicao => {
            if (idCampanhaAquisicao > 0) {
                params = params.append('idCampanhaAquisicao', idCampanhaAquisicao.toString());
            }
        });
        // Sem campanha de aquisição
        if (this.campanhaAquisicaoNull) {
            params = params.append('campanhaAquisicaoNull', 'true');
        }

        // IDs Campanhas de Origens ou Aquisições
        this.idsCampanhasOrigensAquisicoes?.forEach(idCampanhaOrigemAquisicao => {
            if (idCampanhaOrigemAquisicao > 0) {
                params = params.append('idCampanhaOrigemAquisicao', idCampanhaOrigemAquisicao.toString());
            }
        });
        // Sem campanha de origem e aquisição
        if (this.campanhaOrigemAquisicaoNull) {
            params = params.append('campanhaOrigemAquisicaoNull', 'true');
        }


        // Canais de Mídias Socias
        this.canaisMidiasSociais?.forEach(canalMidiaSocial => {
            if (canalMidiaSocial > 0) {
                params = params.append('canalMidiaSocial', canalMidiaSocial.toString());
            }
        });
        // Sem canal
        if (this.canalMidiaSocialNull) {
            params = params.append('canalMidiaSocialNull', 'true');
        }

        // Canais de Venda de Origem
        this.idsCanaisVendaOrigem?.forEach(idCanalVendaOrigem => {
            params = params.append('idCanalVendaOrigem', idCanalVendaOrigem.toString());
        });

        // Tipo da Pessoa
        if (this.tipoPessoa) {
            params = params.append('tipoPessoa', this.tipoPessoa.toString());
        }
        this.tiposPessoas?.forEach(tipoPessoa => params = params.append('tipoPessoa', tipoPessoa.toString()));

        // Periodicidades de Compras
        this.idsPeriodicidadesCompras?.forEach(idPeriodicidadeCompra => params = params.append('idPeriodicidadeCompra', idPeriodicidadeCompra.toString()));
        // Periodicidades de Compras Semanas
        this.periodicidadeCompraSemana?.forEach(periodicidadeCompraSemana => params = params.append('periodicidadeCompraSemana', periodicidadeCompraSemana.toString()));

        // Classificações de itens
        this.idsClassificacoes?.forEach(idClassificacao => {
            if (idClassificacao > 0) {
                params = params.append('idClassificacao', idClassificacao.toString());
            }
        });
        // Sem classificação
        if (this.classificacaoNull) {
            params = params.append('classificacaoNull', 'true');
        }

        // Grupo Econômico
        if (this.idClienteGrupoEconomico) {
            params = params.append('idClienteGrupoEconomico', this.idClienteGrupoEconomico.toString());
        }
        // Cliente ABC
        if (this.clienteAbc) {
            params = params.append('clienteAbc', this.clienteAbc.toString());
        }
        // Nome / Código Integração / CNPJ/CPF
        if (this.filterPsq && this.filterPsq.trim().length > 0) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // CNPJ/CPF
        if (this.cnpjCpf && this.cnpjCpf.trim().length > 0) {
            params = params.append('cnpjCpf', this.cnpjCpf);
        }
        // Código Integração ERP
        if (this.codigoIntegracaoErp && this.codigoIntegracaoErp.trim().length > 0) {
            params = params.append('codigoIntegracaoErp', this.codigoIntegracaoErp);
        }

        // Representante
        if (this.idRepresentante) {
            params = params.append('idRepresentante', this.idRepresentante.toString());
        }
        if (this.idsOutrosRepresentantes && this.idsOutrosRepresentantes.length > 0) {
            this.idsOutrosRepresentantes.forEach(id => {
                if (id > 0) {
                    params = params.append('idRepresentante', id.toString());
                }
            });
        }
        // Sem representante
        if (this.semRepresentante) {
            params = params.append('semRepresentante', 'true');
        }

        // Atendentes
        if (this.idsAtendentes && this.idsAtendentes.length > 0) {
            this.idsAtendentes.forEach(id => {
                params = params.append('idAtendente', id.toString());
            });
        }

        // Cliente atual
        if (this.idClienteAtual) {
            params = params.append('idClienteAtual', this.idClienteAtual.toString());
        }
        // Clientes a serem ignorados
        this.idsIgnore?.forEach(idIgnore => {
            params = params.append('idIgnore', idIgnore.toString());
        });
        // Cidade
        if (this.idCidade) {
            params = params.append('idCidade', this.idCidade.toString());
        }
        // Cidade Sub-Região
        if (this.idCidadeSubRegiao) {
            params = params.append('idCidadeSubRegiao', this.idCidadeSubRegiao.toString());
        }
        // Cidade Sub-Região Bairro
        if (this.idCidadeSubRegiaoBairro) {
            params = params.append('idCidadeSubRegiaoBairro', this.idCidadeSubRegiaoBairro.toString());
        }
        // Estado
        if (this.idEstado) {
            params = params.append('idEstado', this.idEstado.toString());
        }
        // Central de Compras
        if (this.idClienteCentralCompras) {
            params = params.append('idClienteCentralCompras', this.idClienteCentralCompras.toString());
        }
        // Somente central de compra V1
        if (this.somenteCentralDeCompraV1) {
            params = params.append('somenteCentralDeCompraV1', this.somenteCentralDeCompraV1.toString());
        }
        // Somente central de compra
        if (this.somenteCentralDeCompra) {
            params = params.append('somenteCentralDeCompra', this.somenteCentralDeCompra.toString());
        }
        // Somente os clientes que estão disponíveis para serem participantes de uma central de compras
        if (this.somenteParticipaveisCentalDeCompra) {
            params = params.append('somenteParticipaveisCentalDeCompra', this.somenteParticipaveisCentalDeCompra.toString());
        }

        // Data de Cadastro
        if (this.dataCadastroInicial) {
            params = params.append('dataCadastroInicial', toHTTPParam(this.dataCadastroInicial));
        }
        if (this.dataCadastroFinal) {
            params = params.append('dataCadastroFinal', toHTTPParam(this.dataCadastroFinal));
        }

        // Statuses Análise Fianceira
        this.statusesAnaliseFinanceira?.forEach(statusAnaliseFinanceira => {
            params = params.append('statusAnaliseFinanceira', statusAnaliseFinanceira.toString());
        });

        // IDs regiões
        this.idsRegioes?.forEach(idRegiao => {
            if (idRegiao > 0) {
                params = params.append('idRegiao', idRegiao.toString());
            }
        });
        // Sem região
        if (this.regiaoNull) {
            params = params.append('regiaoNull', 'true');
        }


        return params;
    }

    /** Limpa o filtro dos cadastros */
    clearCadastros() {
        this.cadastro = null;
        this.cadastros = [];
    }

    /** Limpa o filtro das situações */
    clearSituacoes() {
        this.situacao = null;
        this.situacoes = [];
    }

    clear() {
        this.isFilterDirty = false;

        /** Cadastro */
        this.somenteClientesEmCarteira = null;
        this.somenteClientesEmCarteiraAtiva = null;
        this.somenteClientesEmCarteiraInativa = null;
        this.somenteClientes = null;
        this.somenteClientesProspects = null;
        this.somenteClientesBloqueados = null;
        this.somenteClientesCongelados = null;
        this.somenteClientesBaixados = null;
        this.somenteClientesOutros = null;
        this.clearCadastros();

        /** Situação */
        this.somenteClientesAtivos = null;
        this.somenteClientesInativos = null;
        this.clearSituacoes();

        this.origens = [];
        this.idsCampanhasOrigens = [];
        this.campanhaOrigemNull = false;
        this.somenteCampanhasOrigemEmAndamento = true;
        this.idsCampanhasAquisicoes = [];
        this.campanhaAquisicaoNull = false;
        this.idsCampanhasOrigensAquisicoes = [];
        this.campanhaOrigemAquisicaoNull = false;
        this.somenteCampanhasAquisicaoEmAndamento = true;
        this.canaisMidiasSociais = [];
        this.canalMidiaSocialNull = null;
        this.idsCanaisVendaOrigem = [];
        this.tipoPessoa = null;
        this.tiposPessoas = [];
        this.idsPeriodicidadesCompras = [];
        this.periodicidadeCompraSemana = [];
        this.idsClassificacoes = [];
        this.classificacaoNull = false;
        this.idClienteGrupoEconomico = null;
        this.clienteAbc = null;
        this.filterPsq = null;
        this.cnpjCpf = null;
        this.codigoIntegracaoErp = null;
        this.idRepresentante = null;
        this.representante = null;
        this.idsOutrosRepresentantes = [];
        this.somenteRepresentantesAtivos = true;
        this.semRepresentante = false;
        this.idsAtendentes = [];
        this.idClienteAtual = null;
        this.idsIgnore = [];
        this.idCidade = null;
        this.idCidadeSubRegiao = null;
        this.idCidadeSubRegiaoBairro = null;
        this.cidade = null;
        this.idEstado = null;
        this.idClienteCentralCompras = null;
        this.clienteCentralCompras = null;
        this.somenteCentralDeCompraV1 = null;
        this.somenteCentralDeCompra = null;
        this.somenteParticipaveisCentalDeCompra = null;
        this.dataCadastroInicial = null;
        this.dataCadastroFinal = null;
        this.statusesAnaliseFinanceira = [];
        this.idsRegioes = [];
        this.regiaoNull = false;
        this.somenteRegioesAtivas = true;
        this.idsTags = [];
    }
}

